<ng-container *ngIf="!!get">
    <ng-container *ngIf="!('mobile' | mediaQuery)">
        <tt-tabs ttRememberId="w_product.bg_main" [(ttSelectedId)]="get.bg_main">
            <tt-tab ttId="EDIT" ttLabel="bg_main_edit" ttIcon="far fa-edit"></tt-tab>
            <tt-tab *ngIf="dashboard.kpiCompKeynos.length > 0" ttId="DASHBOARD" ttLabel="bg_main_dashboard" ttIcon="far fa-analytics"></tt-tab>
            <tt-tab ttId="PRODUCTBOM" ttLabel="bg_main_productbom" ttIcon="far fa-sitemap"></tt-tab>
            <tt-tab ttId="DOCUMENTS" ttLabel="bg_main_documents" ttIcon="far fa-file-alt"></tt-tab>
            <tt-tab *ngIf="get.show_btn_account_product === '1'" ttId="ACCOUNTPRODUCT" ttLabel="bg_main_accountproduct" ttIcon="far fa-file-invoice-dollar"></tt-tab>
            <tt-tab *ngIf="get.show_deviantvat_button === '1'" ttId="DEVIANTVAT" ttLabel="bg_main_deviantvat" ttIcon="far fa-badge-percent"></tt-tab>
            <tt-tab ttId="FUNCTIONS" ttLabel="bg_main_functions" ttIcon="far fa-ellipsis-h"></tt-tab>
        </tt-tabs>

        <tt-product-edit *ngIf="get.bg_main === 'EDIT'" [(params)]="get"></tt-product-edit>
        <tt-webpagemenu-dashboard
            [hidden]="get.bg_main !== 'DASHBOARD'"
            #dashboard
            class="col-xs-12 sp-0"
            ttName="product"
            ttArgtype="prod_id"
            [ttArgvalue]="get.prod_id"
            ttShowHeadingButtons
        ></tt-webpagemenu-dashboard>
        <tt-product-bom *ngIf="get.bg_main === 'PRODUCTBOM'" [params]="{ prod_id: get.prod_keyno }"></tt-product-bom>
        <tt-documents *ngIf="get.bg_main === 'DOCUMENTS'" [params]="{ argtype: 'prod_id', argvalue: get.prod_keyno }"></tt-documents>
        <tt-accountproduct *ngIf="get.bg_main === 'ACCOUNTPRODUCT'" [params]="params"></tt-accountproduct>
        <tt-deviant-vat *ngIf="get.bg_main === 'DEVIANTVAT'" [params]="params"></tt-deviant-vat>
        <tt-card [hidden]="get.bg_main !== 'FUNCTIONS'" class="col-xs-12 sp-2 col-md-3">
            <tt-product-functions [params]="get"></tt-product-functions>
        </tt-card>
    </ng-container>

    <tt-product-edit *ngIf="'mobile' | mediaQuery" [(params)]="get"></tt-product-edit>
</ng-container>
